import ManageGroupsCtrl from '../groups/ManageGroupsCtrl.js';
import config from '../../../config';

import templateUrl from './locationsGroupComponent.html';

class LocationsGroupCtrl extends ManageGroupsCtrl {
  ARCHIVING_LOCATIONS_POSITIONS_ENABLED = config.ARCHIVING_LOCATIONS_POSITIONS_ENABLED;

  constructor(
    PersonaCollection,
    ConfirmService,
    Restangular,
    RestUtils,
    UserUtils,
    Authentication,
    AlertService,
    SalesService,
    $state,
    $parse,
    $document,
    $uibModal,
    filterFilter,
    uppercaseFirstFilter
  ) {
    'ngInject';

    super(
      PersonaCollection,
      ConfirmService,
      Restangular,
      RestUtils,
      Authentication,
      AlertService,
      $state,
      $parse,
      $uibModal,
      filterFilter,
      uppercaseFirstFilter
    );

    Object.assign(this, { SalesService, UserUtils });

    this.$document = $document;
    this.notAllowedTooltip = "You don't have permission to edit this location";
    this.emptyLabel = '-';
  }

  canEditAnyLocation() {
    return this.visibleItems.some((location) => this.canEditLocation(location));
  }

  getLocationImportedTooltipMessage({ origin }) {
    if (!origin) {
      return '';
    }

    const capitalizedOrigin = origin.charAt(0).toUpperCase() + origin.slice(1);
    return `Locations imported from ${capitalizedOrigin} can't be deleted.`;
  }

  canEditLocation(location) {
    return this.UserUtils.canEditGroup(location);
  }
}

export default {
  controller: LocationsGroupCtrl,
  controllerAs: 'ctrl',
  templateUrl,
  bindings: {
    hideHeader: '<?',
    showBudget: '<?',
    displayMyGroups: '<?',
    columnSubset: '<?',
    search: '=?',
    selectedItemIds: '=',
    isSomethingSelected: '=',
    visibleItemsDict: '=',
    updateBudget: '&',
    updateHoursCap: '&',
    groupType: '@',
    cancelCounter: '<',
    saveCounter: '<',
  },
};
